module.exports = {
  APPLE_PAY_PAYMENT_PLATFORM: 'applePay',
  GOOGLE_PAY_PAYMENT_PLATFORM: 'googlePay',
  CREDIT_CARD_PAYMENT_PLATFORM: 'creditCard',
  CREDIT_CARD_FORM_NAME: 'supportersCheckoutForm',
  GENERIC_PAYMENT_PLATFORM: 'genericPay', // likely Microsoft Pay
  PROCESSOR_ERROR_MESSAGES: {
    GENERAL_ERROR:
      'Unable to process this card. Please double check your information and try again.',
    DECLINED_ERROR:
      'Unable to process this card. Please double check your information and try again. If you’re still unable to pay, you may want to get in touch with your bank.',
    PROCESSING_ERROR:
      'Unable to complete transaction. Please double check your connection and try again.',
  },
};
